// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { formatText } = require('core/i18n').i18n;

// @commons
const WizardError = require('components/commons/wizardError/wizardError');

// @constants
const { UNSUCCESFUL_OPERATION } = require("constants/biocatch");

// @ utilities
const { changeBiocatchContext } = require("utilities/biocatch");

const ErrorStep = () => {
    changeBiocatchContext(UNSUCCESFUL_OPERATION);
    const errorMessage = formatText('eCommerceKeyModify-titleError');
    const mainButtonLabel = formatText('eCommerceKeyModify-tryAgain');
    const errorSubMessage = formatText('eCommerceKeyModify-errorSubMessage');
    const errorModifyMessage = formatText ('eCommerceKeyModify-messageModifyError')
    const mainButton = {
        label: mainButtonLabel
    };

    return (
        <div className="col-xs-offset-1 col-xs-10">
            <WizardError errorMessage={errorMessage}
                errorSubMessage={errorSubMessage}
                mainButton={mainButton}
                processType={null}
            >
                {errorModifyMessage}
            </WizardError>
        </div>
    );
};

ErrorStep.propTypes = {
    processType: PropTypes.string,
}

ErrorStep.defaultProps = {
    processType: null,
};

module.exports = ErrorStep;